var _excluded = ["isInverse", "title", "subtitle", "strap", "size", "headingLevel", "utils"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import Type from '../type';
import Utility from '../utility';
import InverseContext from '../../utilities/inverse-context';

/**
 * @ignore @description
 * ## Headline
 * Customize the element, size, and color of the typography's headline.
 *
 * @ignore @see Mesh: [Headline Docs](https://mesh-component-library.apps.csts-k8cnp-ro-1.r-caas.allstate.com/?path=/story/informational-headline--default)
 *
 * @ignore @example
 * ```jsx
 * import { Headline } from 'mesh-component-library';
 *
 *  <Headline title={ <>You've Got <em>Coverage!</em></>}
 *    subtitle="Your confirmation and policies will be emailed to you. Here is your proof of purchase."
 *    strap="Auto 987654321"
 *  />;
 * ```
 */

var Headline = function Headline(props) {
  var isInverse = props.isInverse,
    title = props.title,
    subtitle = props.subtitle,
    strap = props.strap,
    size = props.size,
    headingLevel = props.headingLevel,
    utils = props.utils,
    other = _objectWithoutProperties(props, _excluded);
  var useIsInverse = React.useContext(InverseContext);
  if (isInverse !== 'auto') {
    useIsInverse = isInverse;
  }
  return /*#__PURE__*/React.createElement(Utility.Div, _extends({
    utils: utils
  }, other), strap && /*#__PURE__*/React.createElement(Type, {
    element: "p",
    emphasis: "brand",
    weight: "normal",
    size: "md",
    lineHeight: "md",
    isInverse: useIsInverse
  }, strap), /*#__PURE__*/React.createElement(Type, {
    element: "h".concat(headingLevel),
    emphasis: "brand",
    size: "".concat(size === 'lg' ? '5xl' : '3xl'),
    weight: "semibold",
    lineHeight: "sm",
    utils: {
      vrBottom: 'xs'
    },
    isInverse: useIsInverse
  }, title), subtitle && /*#__PURE__*/React.createElement(Type, {
    element: "p",
    emphasis: "brand",
    weight: "normal",
    size: "md",
    lineHeight: "md",
    isInverse: useIsInverse
  }, subtitle));
};
Headline.propTypes = {
  /** Sets the masthead with the inverse theme variant */
  isInverse: PropTypes.oneOf(['auto', true, false]),
  /** Headline title */
  title: PropTypes.node,
  /** Headline subtitle */
  subtitle: PropTypes.node,
  /** Headline strap */
  strap: PropTypes.node,
  /** Headline size */
  size: PropTypes.oneOf(['md', 'lg']),
  /** Render headline with a semantic elements */
  headingLevel: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  /** Add utility objects for styling */
  utils: PropTypes.object
};
Headline.defaultProps = {
  isInverse: 'auto',
  title: 'Title',
  subtitle: '',
  strap: '',
  size: 'lg',
  headingLevel: 1,
  utils: {}
};
export default Headline;